const KLAVIYO_SCRIPT_PART = 'static.klaviyo.com/onsite/js/';
const KLAVIYO_SCRIPT_URL = 'https://static.klaviyo.com/onsite/js/VLwzih/klaviyo.js?company_id=VLwzih';

function scriptExists(part) {
  return Array.from(document.scripts).some((script) => script.src.includes(part));
}

function appendAsyncScript(src, marker) {
  if (scriptExists(marker)) return;

  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  document.head.append(script);
}

function loadKlaviyo() {
  appendAsyncScript(KLAVIYO_SCRIPT_URL, KLAVIYO_SCRIPT_PART);
}

function runWhenIdle(callback, timeout = 2000) {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(callback, { timeout });
  } else {
    window.setTimeout(callback, 1);
  }
}

let interactionScheduled = false;

function isCartInteraction(event) {
  const target = event?.target;
  if (!(target instanceof Element)) return false;

  return Boolean(target.closest(
    '.drawer--container[data-view="cart-drawer"], .product-buy-buttons--primary, .product-quick-add--button'
  ));
}

function scheduleLoad(event) {
  if (isCartInteraction(event)) return;
  if (interactionScheduled) return;
  interactionScheduled = true;

  window.setTimeout(() => {
    runWhenIdle(loadKlaviyo);
  }, 2000);
}

function observeKlaviyoWidgets() {
  const widget = document.querySelector(
    '#klaviyo-reviews-all, #klaviyo-reviews-list, [id*="klaviyo_reviews"], .klaviyo-form'
  );

  if (!widget || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry?.isIntersecting) return;
      observer.disconnect();
      runWhenIdle(loadKlaviyo, 1000);
    },
    { rootMargin: '900px 0px' }
  );

  observer.observe(widget);
}

if (window.Shopify?.designMode) {
  loadKlaviyo();
} else {
  observeKlaviyoWidgets();

  ['pointerdown', 'touchstart', 'scroll', 'keydown'].forEach((eventName) => {
    window.addEventListener(eventName, scheduleLoad, {
      once: true,
      passive: eventName !== 'keydown'
    });
  });

  window.addEventListener(
    'load',
    () => window.setTimeout(scheduleLoad, 15000),
    { once: true }
  );
}
